<template>
    <div>

        <config-main-title>
            Sinalizador / {{ title_by_model }}
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Sinalizador
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Sinalizador identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Sinalizador'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <draggable v-model="lista" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary">
                    <li class="list-group-item d-flex justify-content-between hover-bg" 
                        class2="'list-group-item-' + dado.st_cor"
                        v-for="(dado, id) in lista" :key="id">
                        <span>
                            <i class="fa-2x fa-fw mr-3" :class="( dado.st_icon ? dado.st_icon : 'fas fa-flag' ) + ' text-' + dado.st_cor" aria-hidden="true"></i>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                            <span v-if="dado.fl_paciente" class="badge badge-secondary ml-2" data-toggle="tooltip" data-placement="top" title="Para Paciente"> 
                                Para Paciente
                            </span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                        </span>
                    </li>
                </draggable>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Sinalizador
                            {{ item && item.id_sinalizador ? '#' + item.id_sinalizador : '(Novo)' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Informe o título do sinalizador..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>
                        
                        <div class="alert alert-info">
                            Informe um ícone da biblioteca <a href="https://fontawesome.com/search?q=smile&o=r&m=free" target="_blank">Font Awesome</a>.
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Figura"
                                    placeholder="Informe..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_icon"
                                    @input="verificar_texto(item)" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :optionsList="[
                                        { id: 'success', search: 'Verde' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'info', search: 'Ciano' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="item.st_cor" />
                            </div>
                        </div>                        
                        <div v-if="item.st_cor" class="my-3">
                            <i class="fa-2x" :class="( item.st_icon ? item.st_icon : 'fas fa-flag' ) + ' text-' + item.st_cor" aria-hidden="true"></i>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="sinalizador" :id="item.id_sinalizador" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_sinalizador ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import draggable from "vuedraggable";

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro', 'model'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        draggable,
    },

    computed: { 
        title_by_model: function () { 
            switch (this.model) {
                case 'fornecedor':
                    return 'Fornecedor';
                default:
                    return this.modelValue;
            }
        },  

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: { 
            get() { 
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                return this.dados && this.dados.length ? 
                    this.dados.filter (item => { 
                        return ( this.viewMode == 'T' || item.fl_ativo ) && 
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    }) : null;
            },

            set(value) { 
                this.$util.atualizar(this, { 
                    service: 'gen_sinalizadores', 
                    func: 'ordem',
                    dados: {
                        lista: value
                    },
                    toast: true, 
                    reload: true, 
                });
            }
        },

    },

    methods: { 
        verificar_texto (item) { 
            if ( item.st_icon && item.st_icon.slice(0,3) == '<i ' && item.st_icon.slice(-4) == '</i>' ) { 
                let texto = item.st_icon.match(/"([^']+)"/);

                if ( texto.length == 2 ) { 
                    item.st_icon = texto[1];
                }
            }
        },

        atualizarOrdem() { 
            //
        },
        
        incluir () { 
            this.validate = false;

            let item = {
                id_sinalizador: null, 
                st_titulo: "", 
                st_cor: "success",
                st_icon: "fas fa-flag", 
                fl_ativo: true, 
                in_regra_ordem: 100, 
                model_type: this.model, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'gen_sinalizadores',
                func: 'index',
                parms: { 
                    cadastro: true, 
                    model_type: this.model,
                }, 
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'gen_sinalizadores',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'gen_sinalizadores',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Sinalizador de Atendimento", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>